/**
 * Click handler for the stars
 *
 * @param event
 */
const clickHander = ( event: Event ) => {
	event.preventDefault();

	if ( event.target instanceof HTMLElement ) {
		const star = event.target;
		const stars = star.parentElement?.querySelectorAll( 'a' );

		const input =
			star.parentElement?.parentElement?.querySelector( 'select' );
		if ( input ) {
			input.value = star.innerHTML;
		}

		if ( stars ) {
			stars.forEach( ( el ) => {
				el.classList.remove( 'active' );
			} );
			star.classList.add( 'active' );

			star.parentElement?.classList.add( 'selected' );
		}
	}
};

export default clickHander;
